import { Component, OnInit, ViewChild } from "@angular/core";
import { Params, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

// Import Enum
import { SortType } from "../../../enum/jubili/company-manage/sort-type";
// Import Model
import { CategoriesQoIndexModel,
  CategoriesQuotation,
   GetQuotationItemModel,
   QuotaionItemlistModel,
   QuotaionItemlistModelIndexModel } from "../../../model/jubili/quotationitem/quotation";
import { SortCompanyModel } from "../../../model/jubili/company-manage/company-sort";
import { QuotationItemService } from "../../../service/api/jubili/quotation-item.service";
import { AuthenticationService } from "../../../service/api/auth/auth.service";
import { Observable, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";

@Component({
    selector: "bo-jub-quotation-item",
    templateUrl: "./quotation-item.component.html",
    styleUrls: ["./quotation-item.component.scss"]
})

export class QuotationItemComponent implements OnInit {
    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private quotationItemService: QuotationItemService,
        private AuthService: AuthenticationService
    ) {
      this.searchTerm$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(term => {
          this.currentSearch = term ? term : null;
          this.categoryPage = 1;
          return new Observable(observer => {
            this.getCategoriesQo(); // ✅ Just calls the function
            observer.complete(); // ✅ Ensures the observable completes
          });
        })
      ).subscribe();
    }

    // using for page list (default)
    page: number = 1;
    lastPage: number = 1;
    limit: number = 100;
    countall: number = 0;
    // using for sort (default)
    sortCol: string = "Docdate";
    sortType: number = SortType.DESC;
    // using for search
    itemsearch: string = "";
    companynamesearch: string = "";
    prospectnamesearch: string = "";
    projectnamesearch: string = "";
    // using for checkbox
    win: boolean = false;
    lost: boolean = false;
    follow: boolean = false;
    wait: boolean = false;
    revise: boolean = false;
    trash: boolean = false;
    // using foe select
  cateqo: string;
  categoryPage: number = 1;
  categorySize: number = 50;
  loadingCategory = false;
  searchTerm$ = new Subject<string | null>();
  currentSearch: string | null = null;

    getQuotationItem: GetQuotationItemModel = new GetQuotationItemModel();
    quotationpageList: Array<QuotaionItemlistModel> = new Array<QuotaionItemlistModel>();
    quotationItemIndex: QuotaionItemlistModelIndexModel = new QuotaionItemlistModelIndexModel();
    getCateIndexqo: CategoriesQoIndexModel = new CategoriesQoIndexModel();
    getCatequotation: CategoriesQuotation[] = [];

  ngOnInit(): void {
    const today = new Date();
    this.getQuotationItem.startdate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    this.setQuotationItemlist();
    this.getCategoriesQo();
  }

    setQuotationItemlist(): void {
        this.getQuotationItem.page = ((this.page - 1) * 100) + 1;
        this.getQuotationItem.limit = this.limit * this.page;
        this.getQuotationItem.sortcol = this.sortCol;
        this.getQuotationItem.sorttype = this.sortType;

        this.quotationItemService.getAllQuotationItemBackOffice(this.getQuotationItem)
        .subscribe(
            Response => {
                this.quotationItemIndex = Response;
                this.quotationpageList = this.quotationItemIndex.data; // set data to show list
                this.countall = this.quotationItemIndex.count;
                this.lastPage = Math.ceil((this.quotationItemIndex.count) / (this.limit));
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                            this.setQuotationItemlist();
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }

  getCategoriesQo(): void {
    this.loadingCategory = true;
    this.quotationItemService.getCategoriesBackOffice(this.categoryPage, this.categorySize, this.currentSearch)
      .subscribe(
        Response => {
          this.loadingCategory = false;
          this.getCateIndexqo = Response;
          if (this.categoryPage == 1) {
            this.getCatequotation = this.getCateIndexqo.data;
          }
          else {
            this.getCatequotation = [...this.getCatequotation, ...Response.data];
          }
          this.loadingCategory = false;

          console.log(this.getCatequotation);
        },
        err => {
          // unauthorized refresh token
          console.log("unauth");
          if (err.status === 401) {
            this.AuthService.refreshSessionToken()
              .subscribe(
                Response => {
                  // Update session
                  this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                  this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                }
              );
            this.setQuotationItemlist();
          } else {
            this.router.navigate(["/home"]);
          }
        }
      );
  }

    // check sort
    // sort user list
    sortList(event: SortCompanyModel): void {
        this.sortCol = event.sortCol;
        this.sortType = event.sortType;
        this.setQuotationItemlist();
    }

    // check date
    updateFromDate(source: any): void {
        this.getQuotationItem.startdate = source.target.valueAsDate;
    }

    updateToDate(source: any): void {
        this.getQuotationItem.enddate = source.target.valueAsDate;
    }

  searchQoItemList(): void {
    this.getQuotationItem.category = this.cateqo.toString();
      this.getQuotationItem.itemsearch = this.itemsearch;
      this.getQuotationItem.companysearch = this.companynamesearch;
      this.getQuotationItem.prospectsearch = this.prospectnamesearch;
      this.getQuotationItem.projectsearch = this.projectnamesearch;
      this.setQuotationItemlist();
    }

    // searchDate(): void {
    //     this.setQuotationItemlist();
    // }

    // // check select
    // selectCateqo(): void {
    //     this.getQuotationItem.category = this.cateqo;
    //     this.setQuotationItemlist();
    // }

    // // check search
    // searchItemname(): void {
    //     this.getQuotationItem.itemsearch = this.itemsearch;
    //     this.setQuotationItemlist();
    // }
    // searchCompanyname(): void {
    //     this.getQuotationItem.companysearch = this.companynamesearch;
    //     this.setQuotationItemlist();
    // }
    // searchProspectname(): void {
    //     this.getQuotationItem.prospectsearch = this.prospectnamesearch;
    //     this.setQuotationItemlist();
    // }
    // searchProjectname(): void {
    //     this.getQuotationItem.projectsearch = this.projectnamesearch;
    //     this.setQuotationItemlist();
    // }
    clearsearch(): void {

        this.itemsearch = "";
        this.companynamesearch = "";
        this.projectnamesearch = "";
        this.prospectnamesearch = "";
        this.getQuotationItem.projectsearch = "";
        this.getQuotationItem.companysearch = "";
        this.getQuotationItem.prospectsearch = "";
      this.getQuotationItem.itemsearch = "";
      const today = new Date();
      this.getQuotationItem.startdate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
      this.getQuotationItem.enddate = today;
      this.win = false;
      this.lost = false;
      this.follow = false;
      this.wait = false;
      this.revise = false;
      this.trash = false;
      this.searchQoItemList();
    }

    // check box
  checkboxwin(check: HTMLInputElement): void {
        this.win = check.checked;
        this.getQuotationItem.quowin = check.checked;
        this.setQuotationItemlist();
    }
    checkboxlost(check: HTMLInputElement): void {
        this.lost = check.checked;
        this.getQuotationItem.quolost = check.checked;
        this.setQuotationItemlist();
    }
    checkboxfollow(check: HTMLInputElement): void {
        this.follow = check.checked;
        this.getQuotationItem.quofollow = check.checked;
        this.setQuotationItemlist();
    }
    checkboxwait(check: HTMLInputElement): void {
        this.wait = check.checked;
        this.getQuotationItem.quowait = check.checked;
        this.setQuotationItemlist();
    }
    checkboxrevise(check: HTMLInputElement): void {
        this.revise = check.checked;
        this.getQuotationItem.quorevise = check.checked;
        this.setQuotationItemlist();
    }
    checkboxtrash(check: HTMLInputElement): void {
        this.trash = check.checked;
        this.getQuotationItem.quotrash = check.checked;
        this.setQuotationItemlist();
    }
    // change page
    backPage(): void {
        if (this.page > 1) {
            this.page--;
            this.setQuotationItemlist();
        }
    }
    nextPage(): void {
        if (this.page < this.lastPage) {
            this.page++;
            this.setQuotationItemlist();
        }
    }
    goTofirstPage(): void {
        if (this.page > 1) {
            this.page = 1;
            this.setQuotationItemlist();
        }
    }
    goTolastPage(): void {
        if (this.page < this.lastPage) {
            this.page = this.lastPage;
            this.setQuotationItemlist();
        }
  }

  loadMoreCategory() {
    this.categoryPage++;
    this.getCategoriesQo();
  }
}
